/// <reference types="user-agent-data-types" />
import {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {detect} from "detect-browser";

export const BrowserSupportModal = () => {
    const [isSupported, setIsSupported] = useState(true);
    const [name, setName] = useState("Unknown Browser");
    const browser = detect();

    useEffect(() => {
        async function fetchHighEntropyData() {
            let supported = false;

            if ((browser?.name === "edge-chromium" || browser?.name === "chrome")) {
                const response = await navigator.userAgentData!.getHighEntropyValues(["wow64"]);

                const wow64 = response.wow64 ?? false;

                if (wow64) {
                    setName(`${browser.name} (32-bit version)`);
                } else {
                    setName(browser.name);
                    supported = true;
                }
            } else {
                setName(browser?.name ?? "Unknown Browser");
            }

            setIsSupported(supported);
        }

        fetchHighEntropyData();
    }, [browser]);
    return (
        <>
            <Modal show={!isSupported}>
                <Modal.Header>
                    <Modal.Title><h3>This browser is not supported.</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        The browser "{name}" is not supported by this application.<br />
                        <br />

                        You must use one of the following browsers:
                        <ul>
                            <li>Chrome (64-bit version)</li>
                            <li>Microsoft Edge (64 bit version)</li>
                        </ul>

                        <br />
                        You may need to contact Application Support to have Chrome 64 installed on your computer.
                        <br />
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};
